<div class="layout">
    <div>
        <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Payment reminder distributions</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-mat-table-generator #matTable [tableName]="'reminderDistributionsTable'"
            [multiselectEnabled]="false"
            [searchEnabled]="false"
            [columns]="reminderDistributionsColumns"
            [dataSource]="reminderDistributionsDataSource"
            [viewLink]="getViewLink">
          </app-mat-table-generator>
        </mat-card-content>
      </mat-card>
    </div>
    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Email logs</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-mat-table-generator #matTable [tableName]="'emailRemindersTable'"
            [multiselectEnabled]="false"
            [columns]="emailRemindersColumns" [dataSource]="emailRemindersDataSource">
          </app-mat-table-generator>
        </mat-card-content>
      </mat-card>

      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>SMS logs</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-mat-table-generator #matTable2 [tableName]="'smsLogTable'"
                                   [multiselectEnabled]="false"
                                   [columns]="smsRemindersColumns" [dataSource]="smsRemindersDataSource">
          </app-mat-table-generator>
        </mat-card-content>
      </mat-card>

    </div>

  </div>
